import { Pipe, PipeTransform } from '@angular/core';

/**
 * @description
 * Pipe que corta uma string no final da útlima palavra antes do limite máximo de caracteres
 * e substitui o final por elipse (...).
 *
 * ### Exemplo
 *
 * string = 'Uma string muito muito longa"
 *
 * <p>{{ string | ellipsis:20 }}</p>
 *
 * saída: Uma string muito...
 */
@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {

  transform(text: string, max: number): string {

    if (!text) return '';
    if (text.length <= max) {
      return text;
    }

    /** String truncada no tamanho máximo, em qualquer caractere */
    let truncada = text.substr(0, max);

    // Se o caractere no tamanho máximo da string já é um espaço ou pontuação, retorna string truncada nesse ponto
    if (text.charAt(max).match(/[,\.\s\/\'\"]/g)) {
      return truncada + '...';
    }

    const maxLength = max - 1;
    let i = maxLength;

    // Calcula o index do último espaço ou pontuação da string
    while (!truncada.charAt(i).match(/[,\.\s\/\'\"]/g) && i > 0) {
      i--;
    }
    truncada = truncada.substr(0, i);

    return truncada + '...';
  }
}
